import { WebsocketContext } from 'contexts/WebsocketContext';
import { useContext } from 'react';

// ==============================|| AUTH HOOKS ||============================== //

const useWebsocket = () => {
  const context = useContext(WebsocketContext);
  if (!context) throw new Error('websocket must be use inside provider');

  return context;
};

export default useWebsocket;
